<template>
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M0 24.3672V32L7.71016 31.9688L15.4203 31.9376L15.4523 24.336L15.4841 16.7344H7.74212H0V24.3672Z"
			fill="white"
		/>
		<path
			d="M0 32V24.3672V16.7344H7.74212H15.4841L15.4523 24.336L15.4203 31.9376L7.71016 31.9688L0 32Z"
			fill="white"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M0.0071904 1.73129C0.0071904 2.68351 0.0498379 3.46259 0.101784 3.46259C0.153853 3.46259 0.976057 2.68351 1.92881 1.73129L3.66111 0H1.83421H0.0071904V1.73129ZM4.31112 4.30152L0 8.60305L0.0345881 10.3618L0.069178 12.1205L6.14347 6.06027L12.2178 0H10.42H8.62211L4.31112 4.30152ZM10.731 6.55419L4.16123 13.1084H5.95602H7.75081L14.3239 6.55455L20.897 0.000618761L19.0989 0.000369547L17.3009 0L10.731 6.55419ZM19.3778 6.46193C15.8154 10.0159 12.9006 12.9653 12.9006 13.0161C12.9006 13.0668 13.6946 13.1084 14.6648 13.1084H16.4291L23.0021 6.55455L29.5753 0.000618761L27.7152 0.000369547L25.8552 0L19.3778 6.46193ZM25.3911 9.11996L18.8514 15.6443V17.4369V19.2295L25.4257 12.6717L32 6.11394L31.9654 4.3547L31.9308 2.59546L25.3911 9.11996ZM25.3911 17.6539L18.8514 24.1817V25.9412C18.8514 26.9089 18.8935 27.7007 18.9449 27.7007C18.9962 27.7007 21.9547 24.7913 25.5191 21.2353L31.9998 14.77L31.9653 12.948L31.9308 11.126L25.3911 17.6539ZM25.8565 25.845L19.7822 31.9053H21.58H23.3779L27.6889 27.6038L32 23.3022L31.9654 21.5435L31.9308 19.7847L25.8565 25.845ZM30.1952 30.174L28.4629 31.9053H30.2278H31.9928V30.174C31.9928 29.2218 31.9781 28.4427 31.9602 28.4427C31.9422 28.4427 31.1479 29.2218 30.1952 30.174Z"
			fill="white"
		/>
	</svg>
</template>
